import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { MISC_PRIMARY, MISC_PRIMARY_HOVER } from '../theme/onboardingTheme'

type Props = { children: ReactNode }

type State = { error: Error | null }

export class WizardErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Onboarding wizard error:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ mx: 'auto', maxWidth: 512, px: 3, py: 8, textAlign: 'center' }}>
          <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#0f172a' }}>
            Something went wrong
          </Typography>
          <Typography sx={{ mt: 1, fontSize: 14, color: '#475569' }}>
            The onboarding wizard hit an error. Try refreshing the page or resetting the demo.
          </Typography>
          <Box
            sx={{
              mt: 2,
              borderRadius: 2,
              backgroundColor: '#fef2f2',
              px: 1.5,
              py: 1,
              textAlign: 'left',
              fontFamily: 'monospace',
              fontSize: 12,
              color: '#991b1b',
            }}
          >
            {this.state.error.message}
          </Box>
          <Button
            type="button"
            variant="contained"
            onClick={() => this.setState({ error: null })}
            sx={{
              mt: 3,
              backgroundColor: MISC_PRIMARY,
              '&:hover': { backgroundColor: MISC_PRIMARY_HOVER },
            }}
          >
            Try again
          </Button>
        </Box>
      )
    }
    return this.props.children
  }
}
